import { IFeedConfiguration } from 'feed';
import { origin } from '~/api/Services';

export const sampleCategories = [
  {
    categoryName: 'Категория 1',
    categoryId: 'sampleCategory1',
  },
  {
    categoryName: 'Категория2',
    categoryId: 'sampleCategory2',
  },
];

export const sampleFeedCards: IFeedCard[] = [
  {
    id: '1',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_1.png`,
    urlLink: '#',
    name: 'Товар 1',
    description: '',
    price: 79.9,
    categoryId: 'sampleCategory1',
  },
  {
    id: '2',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_2.png`,
    urlLink: '#',
    name: 'Товар 2',
    description: '',
    price: 269.9,
    categoryId: 'sampleCategory1',
  },
  {
    id: '3',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_3.png`,
    urlLink:
      'https://www.sberbank.ru/ru/person/bank_cards/debit/sbercard_c?tab=rates',
    name: 'Товар 3',
    description: '',
    price: 229.9,
    categoryId: 'sampleCategory1',
  },
  {
    id: '4',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_4.png`,
    urlLink:
      'https://www.sberbank.ru/ru/person/bank_cards/debit/sbercard_c?tab=rates',
    name: 'Товар 4',
    description: '',
    price: 279.93,
    categoryId: 'sampleCategory1',
  },
  {
    id: '5',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_4.png`,
    urlLink: '#',
    name: 'Товар 5',
    description: '',
    price: 749.9,
    categoryId: 'sampleCategory2',
  },
  {
    id: '6',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_3.png`,
    urlLink: '#',
    name: 'Товар 6',
    description: '',
    price: 69.9,
    categoryId: 'sampleCategory2',
  },
  {
    id: '7',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_2.png`,
    urlLink:
      'https://www.sberbank.ru/ru/person/bank_cards/debit/sbercard_c?tab=rates',
    name: 'Товар 7',
    description: '',
    price: 29.9,
    categoryId: 'sampleCategory2',
  },
  {
    id: '8',
    imgLink: `${
      origin !== 'https://localhost:8080' ? origin : 'https://lk.sberlead.ru'
    }/assets/feed/product_1.png`,
    urlLink:
      'https://www.sberbank.ru/ru/person/bank_cards/debit/sbercard_c?tab=rates',
    name: 'Товар 8',
    description: '',
    price: 249.3,
    categoryId: 'sampleCategory2',
  },
];

export const FEED_DEF_CONFIGURATION: IFeedConfiguration = {
  feedTitle: '',
  feedProductsAmount: 10,

  feedTitleFontFamily: 'Inter',
  feedTitleColor: '#000000',
  feedTitleOpacity: 100,
  feedTitleFontWeight: 'Semi-Bold',
  feedTitleFontSize: 20,
  feedTitleFontItalic: false,
  feedTitleTextLineThrough: false,
  feedTitleTextUnderline: false,

  cardTitleFontFamily: 'Inter',
  cardTitleColor: '#000000',
  cardTitleOpacity: 100,
  cardTitleFontWeight: 'Medium',
  cardTitleFontSize: 16,
  cardTitleFontItalic: false,
  cardTitleTextLineThrough: false,
  cardTitleTextUnderline: false,

  cardDescriptionFontFamily: 'Inter',
  cardDescriptionColor: '#808080',
  cardDescriptionOpacity: 100,
  cardDescriptionFontWeight: 'Normal',
  cardDescriptionFontSize: 14,
  cardDescriptionFontItalic: false,
  cardDescriptionTextLineThrough: false,
  cardDescriptionTextUnderline: false,

  cardPriceFontFamily: 'Inter',
  cardPriceColor: '#000000',
  cardPriceOpacity: 100,
  cardPriceFontWeight: 'Medium',
  cardPriceFontSize: 22,
  cardPriceFontItalic: false,
  cardPriceTextLineThrough: false,
  cardPriceTextUnderline: false,

  cardCrossedPricePosition: 'row',

  cardCrossedPriceFontFamily: 'Inter',
  cardCrossedPriceColor: '#b3b3b3',
  cardCrossedPriceOpacity: 100,
  cardCrossedPriceFontWeight: 'Medium',
  cardCrossedPriceFontSize: 20,
  cardCrossedPriceFontItalic: false,
  cardCrossedPriceTextLineThrough: true,
  cardCrossedPriceTextUnderline: false,

  clickFunctionName: null,
  countCardsInDisplay: null,

  buttonBorderWidth: 1,
  buttonBorderColor: '#000000',
  buttonBorderOpacity: 100,
  hasButtonBorder: true,
  buttonColor: '#ffffff',
  buttonOpacity: 100,
  buttonTextColor: '#000000',
  buttonTextOpacity: 100,
  buttonFontFamily: 'Inter',
  buttonFontWeight: 'Medium',
  buttonFontSize: 16,
  buttonFontItalic: false,
  buttonTextLineThrough: false,
  buttonTextUnderline: false,

  feedBackgroundColor: '#ffffff',
  feedOpacity: 0,
  feedWidth: 99,
  hasCardButton: true,
  hasCardCrossedPrice: false,
  buttonName: 'Подробнее',
  hasCardDescription: false,
  hasCardPrice: true,
  imageSize: 'fill',
  hasCardShadow: true,

  labelsPosition: 'top-left', // 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  labelShadow: false,
  labelTextColor: '#ffffff',
  labelTextColorOpacity: 100,
  labelFontFamily: 'Inter',
  labelFontWeight: 'Medium',
  labelFontSize: 14,
  labelFontItalic: false,
  labelTextLineThrough: false,
  labelTextUnderline: false,
  labels: [
    {
      isActive: true,
      aliasName: '',
      uuid: 'hit',
      text: 'Хит',
      labelBackgroundColor: '#D54242',
      labelBackgroundOpacity: 100,
    },
    {
      isActive: true,
      aliasName: '',
      uuid: 'new',
      text: 'Новинка',
      labelBackgroundColor: '#099768',
      labelBackgroundOpacity: 100,
    },
    {
      isActive: true,
      aliasName: '',
      uuid: 'pop',
      text: 'Популярное',
      labelBackgroundColor: '#007AFF',
      labelBackgroundOpacity: 100,
    },
  ],

  isGroupByCategory: false,
  categoryButtonBorderRadius: 4,
  categoryButtonBorderWidth: 1,
  categoryButtonBorderColor: '#2F3236',
  categoryButtonBorderOpacity: 100,
  hasCategoryButtonBorder: true,
  categoryButtonColor: '#ffffff',
  categoryButtonOpacity: 100,
  categoryButtonFontFamily: 'Inter',
  categoryButtonTextColor: '#000000',
  categoryButtonTextOpacity: 100,
  categoryButtonFontWeight: 'Medium',
  categoryButtonFontSize: 14,
  categoryButtonFontItalic: false,
  categoryButtonTextLineThrough: false,
  categoryButtonTextUnderline: false,

  categoryActiveButtonBorderRadius: 4,
  categoryActiveButtonBorderWidth: 1,
  categoryActiveButtonBorderColor: '#0B1F36',
  categoryActiveButtonBorderOpacity: 100,
  hasCategoryActiveButtonBorder: true,
  categoryActiveButtonColor: '#2F3236',
  categoryActiveButtonOpacity: 100,
  categoryActiveButtonFontFamily: 'Inter',
  categoryActiveButtonTextColor: '#ffffff',
  categoryActiveButtonTextOpacity: 100,
  categoryActiveButtonFontWeight: 'Medium',
  categoryActiveButtonFontSize: 14,
  categoryActiveButtonFontItalic: false,
  categoryActiveButtonTextLineThrough: false,
  categoryActiveButtonTextUnderline: false,
};

export const FEED_MOBILE_DEF_CONFIGURATION: IFeedConfiguration = {
  ...FEED_DEF_CONFIGURATION,
  feedTitleFontSize: 16,
  cardTitleFontSize: 10,
  cardDescriptionFontSize: 10,
  cardPriceFontSize: 14,
  cardCrossedPriceFontSize: 10,
  buttonFontSize: 10,
  labelFontSize: 10,
};
